// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.juw82NCdGPcGd690NNNB{border:1px solid var(--border-neutral-default);border-radius:8px;flex-direction:column;align-items:center;margin-bottom:64px;padding:16px 16px 10px;display:flex}.BSW7GDJ6yU4BFLdpq5kI{margin-left:8px}.fTtKxUri5UXMBtHttNBO{gap:12px;display:flex}.cOfJlgfEdtwE43YZNezh{align-items:center;gap:4px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cardWrapper": `juw82NCdGPcGd690NNNB`,
	"cardImage": `BSW7GDJ6yU4BFLdpq5kI`,
	"cardIcons": `fTtKxUri5UXMBtHttNBO`,
	"cardRightLabel": `cOfJlgfEdtwE43YZNezh`
};
export default ___CSS_LOADER_EXPORT___;
